export const isZoomApp = () => {
    return navigator.userAgent.includes('ZoomWebKit');
};
